import { render, staticRenderFns } from "./custom-input.component.vue?vue&type=template&id=20c7953e"
import script from "./custom-input.component.vue?vue&type=script&lang=js"
export * from "./custom-input.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports